import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PhoneFrame } from "@/components/PhoneFrame";

const WEBSITE_V2_SS = "/screenshots/website-v2";

const HERO_SCREENS = [
  {
    label: "Student Progress",
    src: `${WEBSITE_V2_SS}/hero-student-progress-overview.jpg`,
    alt: "MockTP student progress overview screen",
  },
];

export const PhoneMockups = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeScreen = HERO_SCREENS[activeIndex];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % HERO_SCREENS.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <div
      data-testid="phone-mockups"
      className="relative w-full h-[560px] sm:h-[680px] flex items-center justify-center"
      style={{ perspective: "1200px" }}
    >
      <div className="absolute h-[480px] w-[480px] rounded-full bg-[#00DC82]/[0.12] blur-[120px]" />
      <div className="absolute h-[300px] w-[300px] rounded-full bg-white/[0.04] blur-[90px] -translate-y-16" />

      <div className="relative z-20 flex flex-col items-center justify-center gap-4 sm:gap-5">
        <div className="flex h-8 items-center justify-center">
          <AnimatePresence mode="wait" initial={false}>
            <motion.span
              key={activeScreen.label}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.45, ease: "easeOut" }}
              data-testid="hero-phone-label"
              className="rounded-full border border-[#00DC82]/25 bg-[#00DC82]/[0.08] px-3.5 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#00DC82]"
            >
              {activeScreen.label}
            </motion.span>
          </AnimatePresence>
        </div>

        <div className="relative flex h-[512px] w-[230px] items-center justify-center sm:h-[586px] sm:w-[264px]">
          <AnimatePresence mode="sync" initial={false}>
            <motion.div
              key={activeScreen.label}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
              className="absolute inset-0 flex items-center justify-center"
            >
              <PhoneFrame
                src={activeScreen.src}
                alt={activeScreen.alt}
                widthClass="w-[230px] sm:w-[264px]"
                glow
              />
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};
